import { FormAutocompleteField } from '@components/FormFields';
import { Label } from '@components/Label';
import { FormControlLabel, Stack, Typography } from '@mui/material';
import { selectionsApiSlice } from '@src/api';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLoadingContext } from '../ContentLoading';

export const LabsSelect = () => {
  const { control, setValue } = useFormContext();
  const { setLoadingState } = useLoadingContext() || {};

  const { labs } = selectionsApiSlice.useGetLabsQuery('', {
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      labs: data?.map(({ id, name }) => ({
        name,
        value: id,
        key: id,
      })),
    }),
  });

  useEffect(() => {
    if (labs && setLoadingState) setLoadingState(prev => ({ ...prev, labsCount: labs?.length, labs: true }));
    if (labs?.length === 1) {
      setValue('laboratoryId', labs[0].value, { shouldValidate: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labs?.length, setValue]);

  const onChangeLab = () => {
    setValue('providerId', null, { shouldValidate: true });
    setValue('additionalProductIds', [], { shouldValidate: true });
  };

  if (!labs) return null;
  return labs.length === 1 ? (
    <Stack direction="row" gap="12px" alignItems="center" mt="6px">
      <Typography color="grey.700" variant="label14Bold" lineHeight="18px">
        Laboratory
      </Typography>
      <Typography color="grey.700" variant="label14Medium" lineHeight="18px">
        {labs?.[0].name}
      </Typography>
    </Stack>
  ) : (
    <FormControlLabel
      sx={{ width: '100%' }}
      control={
        <FormAutocompleteField
          name="laboratoryId"
          control={control}
          placeholder="Select"
          options={labs || []}
          onChange={onChangeLab}
          onClear={onChangeLab}
          sx={{ width: '100%' }}
          clearable={false}
        />
      }
      label={<Label label="Laboratory" required />}
      labelPlacement="top"
    />
  );
};
